module.exports = __webpack_public_path__ + "static/img/court.c8502cb7.png";